import {
  Form,
  Modal,
  DatePicker,
  DatePickerInput,
  Select,
  SelectItem,
} from 'carbon-components-react';

import './daily-fee.styles.scss';
import CustomButton from '../../components/custom-button/custom-btn.component';
import {
  getItemById,
  getQueryString,
  hasExpired,
  useReducerSpread,
} from '../../utils/common.util';
import useSWR from 'swr';
import { useHistory } from 'react-router-dom';
import useFetchData from '../../utils/useFetchData';

const initialData = {
  billDate: '',
  classId: '',
  classLabelId: '',
  feeTypeId: '',
  debitAccountId: '',
  genericGroupingId: '',
};

export default function CreateCollection({ isOpen, closeModal }) {
  const [formData, setFormData] = useReducerSpread(initialData);

  const { data: ledgerAccounts } = useSWR('chart-of-accounts/ledger-accounts');

  const { data, isLoading } = useFetchData(
    isOpen ? `daily-billing/fees/assigned-to-user` : null,
  );
  const feeTypes = data?.response ?? [];

  function handleClose() {
    setFormData(initialData);
    closeModal();
  }

  const history = useHistory();

  function isDisabled(item) {
    return hasExpired(item?.invoice?.gracePeriodEndDate);
  }

  const selectedFeetype = getItemById(feeTypes, formData.feeTypeId);
  const isGeneric = selectedFeetype?.type === 'Generic';

  return (
    <Modal
      id="create-collection-modal"
      className="create-collection-modal"
      hasScrollingContent
      passiveModal={true}
      open={isOpen}
      modalHeading="Collect Daily Fee"
      primaryButtonDisabled={false}
    >
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          history.push(`/daily-fees/collect?${getQueryString(formData)}`);
        }}
      >
        <p className="text-14 text-grey-dark">
          Select various options to collect daily fees from students.
        </p>

        <div className="mt-20" style={{ display: 'grid', gap: '20px' }}>
          <DatePicker
            dateFormat="Y-m-d"
            datePickerType="single"
            id="bill-date-picker"
            maxDate={new Date().toISOString().split('T')[0]}
            onChange={(value) => {
              if (value.length > 0) {
                setFormData({
                  billDate: [
                    value[0].getFullYear(),
                    ('0' + (value[0].getMonth() + 1)).slice(-2),
                    ('0' + value[0].getDate()).slice(-2),
                  ].join('-'),
                });
              } else setFormData({ billDate: '' });
            }}
            onClose={(value) => {}}
          >
            <DatePickerInput
              className="bill-date"
              id="bill-date"
              name="billDate"
              labelText="Payment Date"
              value={formData.billDate}
              max={new Date().toISOString().split('T')[0]}
              // pattern="d{1,2}/d{4}"
              pattern="\d{4}-\d{2}-\d{2}"
              autoComplete="off"
              placeholder="YYYY-MM-DD"
              type="text"
              onChange={(e) => setFormData({ billDate: e.target.value })}
            />
          </DatePicker>
          <Select
            labelText="Fee Type"
            onChange={(e) =>
              setFormData({ feeTypeId: e.target.value, genericGroupingId: '' })
            }
          >
            <SelectItem selected value="" text="" />
            {feeTypes?.map((item) => (
              <SelectItem
                key={item.id}
                text={
                  item.name +
                  (isDisabled(item) && item?.invoice?.status
                    ? ` - [${item.invoice.status}]`
                    : '')
                }
                value={item.id}
                disabled={isDisabled(item)}
              />
            ))}
          </Select>
          <Select
            labelText={isGeneric ? 'Group' : 'Class'}
            disabled={!formData.feeTypeId}
            onChange={(e) =>
              setFormData(
                isGeneric
                  ? { genericGroupingId: e.target.value }
                  : { classId: e.target.value },
              )
            }
            value={isGeneric ? formData.genericGroupingId : formData.classId}
          >
            <SelectItem disabled value="" text="" />
            {selectedFeetype?.genericAmounts?.map((item) => (
              <SelectItem key={item.id} text={item.name} value={item.id} />
            ))}
            {selectedFeetype?.classAmounts?.map((item) => (
              <SelectItem
                key={item.id}
                text={item.classDescription}
                value={item.classId}
              />
            ))}
          </Select>

          <Select
            id="debitAccount"
            labelText="Debit Account (Cash or Bank Account)"
            onChange={(e) => setFormData({ debitAccountId: e.target.value })}
          >
            <SelectItem selected disabled text="" value="" />
            {ledgerAccounts
              ?.filter(
                (currentAsset) =>
                  currentAsset.categoryDescription === 'Bank Accounts' ||
                  currentAsset.categoryDescription === 'Cash Accounts',
              )
              .map((currentAsset) => (
                <SelectItem
                  key={currentAsset.id}
                  text={currentAsset.description}
                  value={currentAsset.id}
                />
              ))}
          </Select>
        </div>

        <div
          style={{
            marginTop: '30px',
            display: 'flex',
            gap: '10px',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <CustomButton
            classes="outline danger no-hover font-bold"
            style={{ flex: '1' }}
            onClick={handleClose}
          >
            CLOSE
          </CustomButton>

          <CustomButton
            type="submit"
            style={{ flex: '1' }}
            classes={`primary font-bold`}
            disabled={
              isLoading ||
              !formData.billDate ||
              !formData.feeTypeId ||
              (selectedFeetype?.type === 'Standard' && !formData.classId) ||
              (selectedFeetype?.type === 'Generic' &&
                !formData.genericGroupingId) ||
              !formData.debitAccountId
            }
          >
            Next
          </CustomButton>
        </div>
      </Form>
    </Modal>
  );
}
